import { mantle as viemMantle } from 'viem/chains';

import { getContrastColor } from '@infinex/ui-utils/color';

import {
  defaultEnvironments,
  DEFAULT_CHAIN_LIMITS,
  defaultServices,
  defaultSwidge,
} from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const mantle = {
  displayName: 'Mantle',
  runtime: 'evm',
  viemChain: viemMantle,
  orderPriority: 12,
  isMainnet: true,
  isReleased: true,
  isSupported: true,

  connectivity: {
    rpc: {
      quicknode: {
        chainKey: 'mantle-mainnet',
      },
    },
    blockExplorers: {
      primary: {
        base: 'https://mantlescan.xyz/',
        token: 'https://mantlescan.xyz/token',
      },
    },
  },
  decoration: {
    color: '#FFFFFF',
    get contrastColor() {
      return getContrastColor(this.color);
    },
  },
  environments: defaultEnvironments(true),
  features: {
    wallet: {
      supported: true,
      eip7702: true,
      autoUpgradeSCA: true,
      defaultKind: 'EOA',
      import: true,
    },
    vault: { supported: false, ccqRecovery: false },
  },
  limits: DEFAULT_CHAIN_LIMITS,
  services: defaultServices({
    codex: {
      networkId: 5000,
      nativeLiquidityAddress: '0x78c1b0c915c4faa5fffa6cabf0219da63d7f4cb8',
    },
    coingecko: {
      networkId: 'mantle',
      platformId: 'mantle',
    },
    coingeckoDex: {
      networkId: 'mantle',
    },
    defiLlama: { chainKeys: ['mantle'] },
    trm: { chainKey: 'mantle' },
    zerion: { chainKey: 'mantle' },
    qnStreams: {
      networkKey: 'mantle-mainnet',
    },
    pimlico: { chainSlug: 'mantle' },
  }),
  swidge: defaultSwidge({
    debridge: {
      chainKey: '100000023',
      providerContract: '0x43dE2d77BF8027e25dBD179B491e8d64f38398aA',
    },
    kyberswap: { chainKey: 'mantle' },
    lifi: { chainKey: 'MNT' },
    okx: { chainKey: '5000' },
    stargate: { chainKey: 'mantle' },
  }),
} as const satisfies AllChainConfig<'evm', true>;
